module.exports = __webpack_public_path__ + "img/monthly-billing-icon.6fe833c8.svg";